import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { paginationItems } from '../utils/pagination';
import './TablePagination.css';

export default function TablePagination({ currentPage, totalPages, onPageChange }) {
  return <nav className="table-page-controls" aria-label="Table pagination">
    <button type="button" aria-label="Previous page" disabled={currentPage <= 1 || totalPages === 0} onClick={() => onPageChange(currentPage - 1)}><ChevronLeftIcon /></button>
    {paginationItems(currentPage, totalPages).map(item => typeof item === 'number' ?
      <button type="button" key={item} aria-label={`Page ${item}`} aria-current={item === currentPage ? 'page' : undefined} onClick={() => onPageChange(item)}>{item}</button> :
      <span key={item} className="table-page-gap" aria-hidden="true">…</span>
    )}
    <button type="button" aria-label="Next page" disabled={currentPage >= totalPages || totalPages === 0} onClick={() => onPageChange(currentPage + 1)}><ChevronRightIcon /></button>
  </nav>;
}
